import { render, staticRenderFns } from "./SendCoupon.vue?vue&type=template&id=ea001796&scoped=true&"
import script from "./SendCoupon.vue?vue&type=script&lang=js&"
export * from "./SendCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea001796",
  null
  
)

export default component.exports